import { gql } from "@apollo/client";

export const CREATE_ACCOUNT = gql`
  mutation CreateAccount(
    $name: String!
    $surname: String!
    $email: String!
    $password: String!
    $birthDate: Date!
    $birthPlace: String!
    $phone: String
    $gender: Gender
    $address: String!
    $cap: String!
    $city: String!
    $province: String!
    $codFisc: String!
  ) {
    createUserAppPatient(
      name: $name
      surname: $surname
      email: $email
      password: $password
      birthDate: $birthDate
      birthPlace: $birthPlace
      gender: $gender
      phone: $phone
      address: $address
      cap: $cap
      city: $city
      province: $province
      codFisc: $codFisc
    ) {
      id
    }
  }
`;

export const SEND_QUESTIONS = gql`
  mutation SendQuestions($id: Int!, $answers: String!) {
    setAnswers(user_app_id: $id, content: $answers) {
      id
    }
  }
`;
